
import { InterviewRequest, InterviewRequestResponse, SendRequestResult } from './types';
import { InterviewRequestsService } from './interviewRequestsService';

/**
 * Facade for interview requests operations
 */
export class InterviewRequestsFacade {
  /**
   * Send an interview request via email
   */
  static async sendInterviewRequest(requestData: InterviewRequest): Promise<SendRequestResult> {
    return InterviewRequestsService.sendInterviewRequest(requestData);
  }

  /**
   * Get an interview request by its link
   */
  static async getInterviewRequestByLink(requestLink: string): Promise<InterviewRequestResponse | null> {
    return InterviewRequestsService.getInterviewRequestByLink(requestLink);
  }

  /**
   * Get all interview requests
   */
  static async getAllInterviewRequests(): Promise<InterviewRequestResponse[]> {
    return InterviewRequestsService.getAllInterviewRequests();
  }

  /**
   * Get all archived interview requests
   */
  static async getArchivedInterviewRequests(): Promise<InterviewRequestResponse[]> {
    return InterviewRequestsService.getArchivedInterviewRequests();
  }

  /**
   * Get interview request statistics
   */
  static async getInterviewRequestStatistics(): Promise<any> {
    return InterviewRequestsService.getInterviewRequestStatistics();
  }

  /**
   * Archive an interview request by ID
   */
  static async archiveInterviewRequest(requestId: string): Promise<{ success: boolean; error?: string }> {
    return InterviewRequestsService.archiveInterviewRequest(requestId);
  }

  /**
   * Unarchive an interview request by ID
   */
  static async unarchiveInterviewRequest(requestId: string): Promise<{ success: boolean; error?: string }> {
    return InterviewRequestsService.unarchiveInterviewRequest(requestId);
  }

  /**
   * Delete an interview request by ID
   */
  static async deleteInterviewRequest(requestId: string): Promise<{ success: boolean; error?: string }> {
    return InterviewRequestsService.deleteInterviewRequest(requestId);
  }

  /**
   * Delete all interview requests
   */
  static async deleteAllInterviewRequests(): Promise<{ success: boolean; error?: string }> {
    return InterviewRequestsService.deleteAllInterviewRequests();
  }
}
